import BigNumber from 'bignumber.js'
import lotteryABI from 'config/abi/lottery.json'
import dmdABI from 'config/abi/dmd.json'
import multicall, { multicallWithAbi } from 'utils/multicall'
import { getDmdAddress, getLotteryAddress } from 'utils/addressHelpers'

export const fetchWheelUserData = async (account) => {
  const calls = [
    {
      address: getLotteryAddress(),
      name: 'members',
      params: [account],
      abi: lotteryABI,
    },
    {
      address: getDmdAddress(),
      name: 'balanceOf',
      params: [account],
      abi: dmdABI,
    },
    {
      address: getDmdAddress(),
      name: 'allowance',
      params: [account, getLotteryAddress()],
      abi: dmdABI,
    },
    {
      address: getLotteryAddress(),
      name: 'tickets',
      params: [account],
      abi: lotteryABI,
    },
    {
      address: getLotteryAddress(),
      name: 'userRewardDMD',
      params: [account],
      abi: lotteryABI,
    },
  ]
  const [memberInfo, dmdBalanceFC, allowanceFC, ticketsFC, pendingRewardFC] = await multicallWithAbi(calls)

  return {
    isSers: memberInfo.isExist,
    dmdBalance: new BigNumber(dmdBalanceFC[0]._hex),
    allowance: new BigNumber(allowanceFC[0]._hex),
    tickets: ticketsFC[0],
    pendingReward: new BigNumber(pendingRewardFC[0]._hex),
  }
}

export const fetchWheelUserPurchasedNumbers = async (account) => {
  const [roundIdFC] = await multicall(lotteryABI, [
    {
      address: getLotteryAddress(),
      name: 'roundId',
    },
  ])
  const roundId = new BigNumber(roundIdFC[0]._hex).toNumber()

  const calls = [...Array(1000)].map((i, index) => ({
    address: getLotteryAddress(),
    name: 'readTicketToUsers',
    params: [roundId, index],
  }))
  const data = await multicall(lotteryABI, calls)
  const purchasedNumbers = data
    ?.map((item, index) => ({ number: index + 1, addresses: item[0] }))
    .filter((item) => item.addresses.includes(account))
    .map((item) => item.number)

  return purchasedNumbers || []
}
